module.exports = __webpack_public_path__ + "static/media/user.e4f421c5.png";